












import { Vue, Component, Prop, Emit } from "vue-property-decorator";

@Component
export default class RequestTabs extends Vue {
  tab: number | null = null;

  @Prop({ type: Array, default: () => [] })
  tabNames!: string[];

  @Emit("change")
  emitChange(): number {
    return this.tab as number;
  }
}
